<template>
  <div>
    <BaseTitle :title="$t('content.course_title')" :yearPeriode="titleData" />
    <div v-if="loading" class="text-center">
      <v-progress-circular indeterminate color="white" />
    </div>
    <v-row v-else>
      <template v-if="user.cerdasTypeId === 2 || user.cerdasTypeId === null">
        <v-col v-for="item in items" :key="item.courseId" md="4" @click="gotoPage(item)">
          <div class="class-item d-flex justify-space-between">
            <div>
              <v-img v-if="item.url" :src="item.url" width="79" height="70" />
              <svg-icon v-if="item.url === null || !item.url" icon="course-list" width="79" height="70" />
            </div>
            <strong class="class-item-name">{{ item.name }} </strong>
            <br v-if="role != 4" />
            <v-btn text class="btn-action-custom" v-if="role === 4" @click="popUpItem(item)"><svg-icon icon="edit" class="primary--text"/></v-btn>
          </div>
        </v-col>
      </template>
      <template v-if="user.cerdasTypeId === 1">
        <v-col v-for="item in items" :key="item.courseId" md="4" @click="gotoPage(item)">
          <div class="class-item d-flex justify-space-between">
            <div>
              <v-img v-if="item.url" :src="item.url" width="79" height="70" />
              <svg-icon v-if="item.url === null || !item.url" icon="course-list" width="79" height="70" />
            </div>
            <strong class="class-item-name">{{ item.name }} </strong>
            <br />
            <template v-if="items.length && user.cerdasTypeId === 1 && type === 'teacher'">
              <div class="pa-5">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <span dark v-bind="attrs" v-on="on">
                      <svg-icon icon="ic-moreaction-black" class="mt-1" />
                    </span>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title class="text-dropdown" @click="editDetail(item)">{{ $t('edit') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title class="text-dropdown-delete" @click="dialogdelete(item)">{{ $t('table.delete') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </template>
          </div>
        </v-col>
      </template>
    </v-row>
    <!-- <template>
      <div v-if="!items.length" class="succ">
        <div class="succ-content">
          <svg-icon icon="ic-nodata-mini" class="succ-featured" width="130" height="100" />
          <h1 class="succ-heading">{{ $t('nodata_title') }}</h1>
          <div class="succ-content mb-8">{{ $t('nodata_body') }}</div>
        </div>
      </div>
    </template> -->
    <template
      v-if="
        (user.cerdasTypeId === 2 && type === 'teacher') ||
          (user.cerdasTypeId === null && type === 'parent') ||
          (user.cerdasTypeId === 2 && type === 'student') ||
          (user.cerdasTypeId === null && type === 'school-advisor')
      "
    >
      <v-divider class="mt-8" v-if="items.length" />

      <!-- E-rapor -->
      <v-card shaped class="pa-3 mt-5" style="width:100px;">
        <div class="app-section-title text-center">
          E-rapor
        </div>
      </v-card>

      <v-row>
        <v-col md="4" @click="gotoPageErapor()">
          <div class="class-item d-flex justify-space-between">
            <div>
              <svg-icon icon="ic-course" width="98" height="70" />
            </div>
            <strong> E-rapor </strong>
            <br />
          </div>
        </v-col>
      </v-row>
    </template>
    <div class="pa-5 fixed-card" v-if="items.length && user.cerdasTypeId === 1 && type === 'teacher'">
      <v-row>
        <v-col md="9" class="mt-2">
          <span class="succ-heading mr-2"> {{ $t('content.add_course_title') }} !</span>
          <span>{{ $t('content.add_course_content_1') }}</span>
        </v-col>
        <v-btn color="primary" class="btn-primary-custom mb-2 mb-md-0 mr-md-2 mt-3 ml-2" @click="dialogPopUpForm = true">{{
          $t('content.add_course')
        }}</v-btn>
      </v-row>
    </div>

    <!-- Dialog Upload Foto -->
    <v-dialog v-model="dialogPopUp" persistent max-width="607">
      <v-card>
        <v-card-title class="headline secondary white--text">
          {{ $t('content.course_image') }}
        </v-card-title>
        <v-card-subtitle class="headline d-flex justify-center pa-5">
          <form-group :name="$t('form.image')" :validator="$v.form.image" no-gutter>
            <template slot-scope="{ attrs }">
              <image-box
                :key="imageBoxKey"
                v-model="form.image"
                v-bind="attrs"
                with-upload
                :upload-btn-text="$t('upload')"
                :image-preview="itemTemporary.url"
                @change="$v.form.image.$touch()"
                class="mt-4"
              />
            </template>
          </form-group>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer />
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="dialogClose">{{ $t('back') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" type="submit" @click="editCourse(itemTemporary.courseId)">{{ $t('submit') }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Course Lite -->
    <v-dialog v-model="dialogPopUpForm" persistent max-width="607">
      <v-card>
        <v-card-title class="headline secondary white--text">
          {{ $t('content.add_course') }}
        </v-card-title>
        <v-card-subtitle class="headline d-flex justify-center pa-5">
          <v-row>
            <v-col cols="12" md="4" class="py-0">
              <form-group :name="$t('table.grade')">
                <template slot-scope="{ attrs }">
                  <v-text-field v-model="formInput.gradeName" disabled v-bind="attrs" :label="$t('table.grade')" />
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="4" class="py-0">
              <form-group :name="$t('content.classroom')">
                <template slot-scope="{ attrs }">
                  <v-text-field v-model="formInput.classroomName" disabled v-bind="attrs" :label="$t('content.classroom')" />
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="4" class="py-0">
              <form-group :name="$t('form.schoolyear')">
                <template slot-scope="{ attrs }">
                  <v-text-field v-model="formInput.yearPeriode" disabled v-bind="attrs" :label="$t('form.schoolyear')" />
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" :md="statusModal === true ? 6 : 12" class="py-0">
              <form-group :name="$t('menu.course')" :validator="$v.formInput.courseId">
                <template slot-scope="{ attrs }">
                  <v-select
                    v-model="formInput.courseId"
                    v-bind="attrs"
                    item-value="courseId"
                    item-text="name"
                    :disabled="statusModal === true"
                    :items="listCourse"
                    :label="$t('menu.course')"
                    @input="$v.formInput.courseId.$touch()"
                    @blur="$v.formInput.courseId.$touch()"
                  />
                </template>
              </form-group>
            </v-col>
            <v-col v-if="statusModal === true" cols="12" md="6" class="py-0">
              <form-group :name="$t('form.status')" :validator="$v.formInput.status">
                <template slot-scope="{ attrs }">
                  <v-select
                    :items="status"
                    :label="$t('form.status')"
                    v-bind="attrs"
                    v-model="formInput.status"
                    width="100"
                    @input="$v.formInput.status.$touch()"
                    @blur="$v.formInput.status.$touch()"
                  >
                    <template #item="{item}">
                      {{ $t(item.text) }}
                    </template>
                    <template #selection="{item}">
                      {{ $t(item.text) }}
                    </template>
                  </v-select>
                </template>
              </form-group>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer />
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="closePopup">{{ $t('back') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" type="submit" @click="addCourse">{{ $t('submit') }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Delete Class -->
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
        <v-card-text>{{ $t('delete_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelDelete">{{ $t('disagree') }}</v-btn>
          <v-btn text :loading="loading" @click="deleteDetail">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import { fileSize } from '@/validators';
import { required } from 'vuelidate/lib/validators';

import ImageBox from '@/components/ImageBox';

export default {
  name: 'CourseList',
  props: {
    type: {
      type: String
    }
  },
  components: {
    BaseTitle,
    ImageBox
  },
  computed: {
    ...mapGetters({
      items: 'CourseList/items',
      role: 'Auth/currentRole',
      student: 'Auth/student',
      isAuthenticated: 'Auth/isAuthenticated',
      user: 'Auth/user',
      status: 'Reference/itemStatus'
    }),
    titleData() {
      if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
        return `${this?.dataClass?.classroomName ?? ''} ${this?.dataClass?.yearPeriode ? `(${this?.dataClass?.yearPeriode})` : ''}`;
      } else {
        return `${this?.dataClass?.gradeName ?? ''} ${this?.dataClass?.classroomName ?? ''} ${
          this?.dataClass?.yearPeriode ? `(${this?.dataClass?.yearPeriode})` : ''
        }`;
      }
    }
  },
  validations: function() {
    return {
      form: {
        image: { fileSize: fileSize(1), required }
      },
      formInput: {
        courseId: { required },
        status: this.statusModal === true ? { required } : {}
      }
    };
  },
  data: () => ({
    loading: false,
    dialogPopUp: false,
    dialogDelete: false,
    dialogPopUpForm: false,
    itemCourse: '',
    singleChild: '',
    dataClass: '',
    imageUrl: null,
    itemTemporary: '',
    form: {
      image: null
    },
    formInput: {
      classroomId: '',
      classroomName: '',
      courseId: '',
      gradeName: '',
      yearPeriode: '',
      status: ''
    },
    search: '',
    listCourse: [],
    statusModal: false,
    imageBoxKey: Date.now()
  }),
  watch: {
    student: {
      deep: true,
      handler() {
        if (this.isAuthenticated) {
          this.$router.push({ name: 'ParentClassIndex' });
        }
      }
    }
  },
  methods: {
    closePopup() {
      this.dialogPopUpForm = false;
      this.statusModal = false;
    },
    getData() {
      const id = this.role === 3 ? this.student.studentId : this.$route.params.classId;
      const payload = { id: id, classid: this.$route.params.classId };
      this.loading = true;
      this.$store.dispatch('CourseList/fetchList', payload).finally(() => (this.loading = false));
    },
    getCourselite() {
      this.loading = true;
      this.$store
        .dispatch(`CourseSchool/fetchListLiteClass`, {
          classroomId: this.$route.params.classId
        })
        .then(data => (this.listCourse = data))
        .finally(() => (this.loading = false));
    },
    editDetail(item) {
      this.$store.dispatch('CourseList/fetchListLiteDetail', { classroomId: this.$route.params.classId, courseId: item.courseId }).then(res => {
        Object.keys(this.formInput).forEach(formInput => {
          this.formInput[formInput] = res[formInput];
        });
        this.statusModal = true;
        this.dialogPopUpForm = true;
        this.classroomId = this.$route.params.classId;
      });
    },
    popUpItem(item) {
      this.itemTemporary = { ...item };
      this.dialogPopUp = true;
    },
    editCourse(courseId) {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) return false;

      var classId = this.$route.params.classId;
      this.$store
        .dispatch('CourseList/uploadProfile', { courseId, classId, ...this.form })
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.getData();
          this.getCourselite();
          this.form.image = null;
          this.itemTemporary = null;
          this.dialogPopUp = false;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => this.$v.$reset());
    },
    dialogClose() {
      this.imageBoxKey = Date.now();
      this.form.image = null;
      this.itemTemporary.url = null;
      this.dialogPopUp = false;
      this.$v.$reset();
    },
    getSingleChild() {
      this.loading = true;
      return this.$store.dispatch('ChildList/fetchList').finally(() => (this.loading = false));
    },
    getDataClass() {
      if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
        this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(res => (this.dataClass = res));
      } else {
        this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(res => {
          this.dataClass = res;
          Object.keys(this.formInput).forEach(formInput => {
            this.formInput[formInput] = res[formInput];
          });
        });
      }
    },
    setStudent(item) {
      this.$store.commit('Auth/SET_STUDENT', item);
      this.$router.push({ name: 'ParentCourseIndex' });
    },
    addCourse() {
      this.$v.formInput.$touch();
      if (this.$v.formInput.$invalid) {
        return false;
      }

      this.loading = true;
      const payload = { ...this.formInput };

      this.$store
        .dispatch(`CourseList/${this.statusModal === false ? 'savelite' : 'updatelite'}`, payload)
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => {
          this.loading = false;
          this.dialogPopUpForm = false;
          this.getData();
          this.formInput.courseId = '';
          this.statusModal = false;
          this.$store.dispatch('general/showSuccessNotification', { message: 'Success' });
          this.$v.$reset();
        });
    },
    gotoPage({ courseId, name, referalCode }) {
      this.$store.commit('CourseList/SET_CODE', referalCode);
      this.$store.commit('CourseList/SET_NAME', name);
      if (this.dialogPopUp === false) {
        const params = { courseId, classId: this.$route.params.classId };
        localStorage.setItem('courseName', name);

        this.$store.dispatch(`ClassSection/getListClassSection`, { ...params }).then(stat => {
          const status = stat.classSection;
          switch (this.type) {
            case 'teacher':
              if (status === false) {
                this.$router.push({ name: 'TeacherMenuList', params });
              } else {
                this.$router.push({ name: 'TeacherClassSectionList', params });
              }
              break;
            case 'parent':
              if (status === false) {
                this.$router.push({ name: 'ParentCourseList', params });
              } else {
                this.$router.push({ name: 'ParentClassSectionList', params });
              }
              break;
            case 'student':
              if (status === false) {
                this.$router.push({ name: 'StudentCourseList', params });
              } else {
                this.$router.push({ name: 'StudentClassSectionList', params });
              }
              break;
            case 'school-advisor':
              if (status === false) {
                this.$router.push({ name: 'AdvisorMenuList', params });
              } else {
                this.$router.push({ name: 'AdvisorClassSectionList', params });
              }
              break;
          }
        });
      }
    },
    gotoPageErapor() {
      switch (this.type) {
        case 'teacher':
          this.$router.push({ name: 'EraporTeacherView' });
          break;
        case 'parent':
          this.$router.push({ name: 'EraporParentView' });
          break;
        case 'student':
          this.$router.push({ name: 'EraporStudentView' });
          break;
        case 'school-advisor':
          this.$router.push({ name: 'EraporAdvisorView' });
          break;
      }
    },
    dialogdelete(item) {
      this.itemCourse = item;
      this.dialogDelete = true;
    },
    cancelDelete() {
      this.dialogDelete = false;
      this.itemCourse = null;
    },
    deleteDetail() {
      this.loading = true;
      this.$store
        .dispatch('CourseList/destroy', { courseId: this.itemCourse.courseId, classroomId: this.$route.params.classId })
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.getData();
          this.dialogDelete = false;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loading = false));
    }
  },
  created() {
    if (this.user.cerdasTypeId === 1 && this.type === 'teacher') {
      this.getCourselite();
    }
    if ((this.role === 3 && !!this.student) || this.role === 4 || this.role === 6 || (this.role === 5 && !this.student)) {
      this.getData();
      this.getDataClass();
    } else {
      this.getDataClass();
      this.getSingleChild().then(student => {
        if (student.length == 1) {
          this.setStudent(student[0]);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.class-item {
  display: flex;
  align-items: center;
  border-radius: 8px;
  box-shadow: 0 7px 16px 0 rgba(0, 0, 0, 0.13);
  background: #fff;
  padding: 20px;
  cursor: pointer;

  &:hover {
    background: #f8f8f8;
  }

  &-name {
    word-break: break-all;
    width: fit-content;
  }
}
.succ {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    font-size: 12px;
  }

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }

  &-heading {
    color: #6d6d6d;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 16px;
  }
}
.image-box {
  position: relative;

  &-preview {
    width: 245px;
    height: 198px;
    background: #fff;
    background-color: #f2f2f2;
    border: 1px solid #979797;
    box-sizing: border-box;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
  }

  &-file {
    width: 0;
    display: none;
  }
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
  &-grey {
    color: grey;
    cursor: pointer;
  }
}

.fixed-card {
  position: absolute;
  bottom: 0;
  background-color: #ffffff;
  width: 74%;
  border-radius: 8px;
  box-shadow: 0 7px 16px 0 rgba(0, 0, 0, 0.13);
}
.high {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 24px;
  line-height: 29px;
  text-align: left;
}
</style>
